import React from 'react';
import { AdresseQueryPayload } from '../types';
import { useAdresse } from '../queries/query-hooks';
import { Column, Header, Text, TextLink } from '@mattilsynet/mt-ui';
interface IOverordnetOrgnummerProps {
  payload: AdresseQueryPayload;
}
export const OverordnetOrgnummer = ({
  payload
}: IOverordnetOrgnummerProps) => {
  const {
    data,
    isFetched
  } = useAdresse(payload);
  const {
    overordnetOrgNr
  } = data ?? {};
  const hasOrgNr = overordnetOrgNr !== undefined;
  if (!isFetched) return;
  return <Column spacing={1} data-sentry-element="Column" data-sentry-component="OverordnetOrgnummer" data-sentry-source-file="OverordnetOrgnummer.tsx">
      <Header as="h3" size="normal" data-sentry-element="Header" data-sentry-source-file="OverordnetOrgnummer.tsx">
        Overordnet org nr
      </Header>
      {!hasOrgNr && <Text>Intet registrert overordnet org nr</Text>}
      {hasOrgNr && <>
          <Column>
            <Text textAlign="left">{overordnetOrgNr}</Text>
          </Column>
          <Column>
            <TextLink href={`https://w2.brreg.no/enhet/sok/detalj.jsp?orgnr=${overordnetOrgNr}`} linkOutside>
              Vis overordnet enhet
            </TextLink>
          </Column>
        </>}
      &nbsp;
    </Column>;
};